import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IResponse } from "@app/lib/models/response.model";
import { AppConfiguration } from "@app/lib/services/app-config.service";
import { BaseHttpService } from "@app/lib/services/base-http.service";
import { ICourtSessionPanel, IJudge, ISessionData } from "../models/case-assignment.model";

@Injectable({
  providedIn: 'root'
})
export class JudgePanelAssignmentService extends BaseHttpService {


  constructor(
    http: HttpClient,
    appConfig: AppConfiguration,
  ) {
    super(http, appConfig);
  }

  getSession() {
    return this.get<IResponse<ISessionData[]>>('mtSession-master/get/lov.htm');
  }
  getpanels(params: any) {
    return this.get<IResponse<ICourtSessionPanel[]>>('court-panel/court/session/panels.htm', { params });
  }

  getAvailableJustices(reqBody: any) {
    return this.post<IResponse<any>, any>('justicePanel-assign/get/available-justice.htm', reqBody);
  }
  getAvailableJusticesReassign(reqBody: any) {
    return this.post<IResponse<any>, any>('case-phase/get/available-judges.htm', reqBody);
  }

  getPanelJustices(reqBody: any) {
    return this.post<IResponse<any>, any>('justicePanel-assign/get.htm', reqBody);
  }
  getAssignedJustices(reqBody: any) {
    return this.post<IResponse<any>, any>('case-phase/get/assigned-judges.htm', reqBody);
  }

  getPanelCounts(reqBody: any) {
    return this.post<IResponse<any>, any>('mtjustice-panel/search.htm', reqBody);
  }
  savePanel(reqBody: any) {
    return this.post<IResponse<any>, any>('justicePanel-assign/upsert.htm', reqBody, { params: { 'transType': 'I' } });
  }

  saveAssignedJudges(reqBody: any) {
    return this.post<IResponse<any>, any>('case-phase/assign-judge.htm', reqBody);
  }

  getCasephases(reqBody: any) {
    return this.get<IResponse<any>>('case-phase/search.htm', { params: reqBody });
  }

}